import React from 'react';
import { FlatList, Image, Modal } from "react-native"
import type { AthleteProps, BracketCompetitionProps, CompetitionPlayerBracketProps, PlayerBracketProps, TeamProps } from "../../types"
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { BracketCompetitionHelpers } from '../api';

type EnteredCompetitionsModalProps = {
    view_mode: 'desktop'|'mobile',
    player_bracket?:PlayerBracketProps,
    insets?:{ top:number, bottom:number, left:number, right:number },
    entered_competitions:BracketCompetitionProps[],
    entered_brackets:CompetitionPlayerBracketProps[],
    champion_team?:TeamProps,
    champion_athlete?:AthleteProps,
    onClose:() => void,
    onSelectCompetition:(bracket_competition:BracketCompetitionProps) => void
}
const EnteredCompetitionsModal = ({ view_mode, champion_athlete, champion_team, player_bracket, insets, entered_brackets, entered_competitions, onClose, onSelectCompetition }:EnteredCompetitionsModalProps) => {
    const Colors = useColors();

    const renderCompetitions = (data:{item:BracketCompetitionProps, index:number}) => {
        const cl = data.item.market_type == 'FOR_MONEY' ? "$" : 'E'
        const cpb = entered_brackets.find(b => b.bracket_competition_id == data.item.bracket_competition_id && b.player_bracket_id == player_bracket?.player_bracket_id);
        let pot = BracketCompetitionHelpers.getPayout(data.item)
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }} onPress={() => onSelectCompetition(data.item)}>
                <Image
                    source={{ uri: data.item.image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2'>{data.item.competition_name}</Text>
                    {cpb ?
                    <Text style={{ marginTop:3 }}>{pot > 0 ? `Total Pot: ${cl}${pot.toFixed(2)}`:''}Place {cpb.place} / {data.item.tickets_sold}</Text>
                    :<></>}
                </View>
                {cpb ?
                <View style={{ justifyContent:'center', alignItems:'center', marginRight:20, marginLeft:20 }}>
                    <Text theme='h2' color={Colors.text.success} textAlign='center'>{cl}{cpb.winnings.toFixed(2)}</Text>
                    <Text theme='description' color={Colors.text.success} textAlign='center'>winnings</Text>
                </View>
                :<></>}
                <Icons.ChevronIcon direction='right' size={10} color={Colors.text.action} />
            </Button>
        )
    }

    return (
        <Modal
            visible={player_bracket?true : false}
            style={{ flex:1 }}
            transparent
            animationType={view_mode == 'desktop' ? 'fade' : 'slide'}
            >
            <View type='blur' style={view_mode == 'desktop' ? { flex:1, justifyContent:'center', alignItems:'center' } : { flex:1, justifyContent:'flex-end', paddingBottom:(insets?.bottom ?? 0)}}>
                <View float style={view_mode == 'desktop' ? { width:500 }:{ margin:10 }}>
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                        <View transparent style={{ flex:1 }}>
                            <Text theme='h1'>{player_bracket?.bracket_name ?? ''}</Text>
                            <Text style={{ marginTop:3 }} theme='description'>Entered Competitions</Text>
                        </View>
                        {player_bracket?
                        <View transparent>
                            <Text theme='h1' color={Colors.text.h1}>{(player_bracket.completion_pct*100).toFixed(2)}%</Text>
                        </View>
                        :<></>}
                        {champion_team ? 
                        <View transparent style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                            <Image
                                source={{ uri: champion_team.image?.url }}
                                style={{ height:30, width:30 }}
                                resizeMode='cover'
                            />
                            <Text theme="description" textAlign="center">{champion_team.abbr}</Text>
                        </View>
                        :champion_athlete ?
                        <View transparent style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                            <Image
                                source={{ uri: champion_athlete.image?.url }}
                                style={{ height:30, width:30 }}
                                resizeMode='cover'
                            />
                            <Text theme="description" textAlign="center">{champion_athlete.abbr_name}</Text>
                        </View>
                        :<></>}
                    </View>
                    <View type='body' style={{ flexGrow:1 }}>
                        <FlatList
                            key={'entered_comps'}
                            keyExtractor={(item) => item.bracket_competition_id}
                            data={entered_competitions}
                            renderItem={renderCompetitions}
                        />
                    </View>
                    <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomLeftRadius:8, borderBottomRightRadius:8 }}>
                        <Button
                            type='close'
                            title='CLOSE'
                            style={{ flex:1 }}
                            onPress={() => onClose()}
                        />
                    </View>
                </View>
            </View>

        </Modal>
    )
}

export default EnteredCompetitionsModal